// PrivateRoute.js
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import NavBar from './shared-components/NavBar';

const PrivateRoute = () => {
  const { auth, isExpired } = useAuth();

  if (!auth || isExpired()) {
    return <Navigate to="/login" replace />;
  }

  if (window.location.pathname === '/') {
    return <Navigate to="/promos" replace />;
  }

  return (
    <main className="d-flex flex-nowrap">
      <NavBar />
      <Outlet />
    </main>
  );
};

export default PrivateRoute;
